// 必须是首条 import：在登录跳转/埋点/第三方脚本改写地址栏之前捕获飞书回调凭证
import './bootstrap/larkCallback'
import './registerServiceWorker'
import './init'
import { renderApp } from './render'

renderApp()

try {
  const { version } = require('../package.json')
  console.log(
    `
%c主应用版本: v${version}
________                            _______________
___  __ \\________      _______________  ____/_  __ \\
__  /_/ /  __ \\_ | /| / /  _ \\_  ___/  / __ _  / / /
_  ____// /_/ /_ |/ |/ //  __/  /   / /_/ / / /_/ /
/_/     \\____/____/|__/ \\___//_/    \\____/  \\____/

`,
    'color: #00bebe;font-weight: bold;font-size: 14px;',
  )
} catch (e) {}
